import { Layout as AntLayout } from 'antd'
import React, { FC } from 'react'
import LinkExpired from '../../components/Authentication/LinkExpired'
import ResetPasswordForm from '../../components/Authentication/ResetPasswordForm'
import EmptyHeader from '../../components/Layout/Header/EmptyHeader'
import Footer from '../../components/Layout/Footer'
import ContactBloc from '../../components/Layout/InfoBloc/ContactBloc'
import Layout from '../../components/Layout/Layout'
import SectionWithInfo from '../../components/Layout/SectionWithInfo'
import useTokenValidation from '../../services/useTokenValidation.hook'

const ResetPassword: FC<void> = () => {
  const [warning, token, email] = useTokenValidation()

  return (
    <Layout>
      <EmptyHeader />
      <AntLayout.Content>
        <SectionWithInfo infoBloc={<ContactBloc />}>
          {warning ? (
            <LinkExpired />
          ) : (
            <ResetPasswordForm token={token} email={email} />
          )}
        </SectionWithInfo>
      </AntLayout.Content>
      <Footer />
    </Layout>
  )
}

export default ResetPassword
